import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import MessageModel from "@/commons/models/Message";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 家族メッセージ API 操作クラス
 */
export default class MessagesInFamily {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET FamilyMessages
   */
  public async get(
    userStore: LoginUser,
    residentId: number,
    familyId: number,
    queryParams: { end: number; startIndex: number; endIndex: number; order: string }
  ): Promise<Array<MessageModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      residentId: residentId,
      familyId: familyId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.MessagesInFamily, formatParams);
    const response = await this.commonService.executeGet<Array<MessageModel>>(userStore, requestUrl, this.constructor.name, queryParams, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * GET FamilyMessagesCount
   */
  public async getCount(userStore: LoginUser, residentId: number, familyId: number): Promise<number> {
    // countの場合は末尾に「count」をつける
    const formatParams: any = {
      facilityId: userStore.facility.id,
      residentId: residentId,
      familyId: familyId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.MessagesInFamily, formatParams);
    const response = await this.commonService.executeGet<{ count: number }>(userStore, `${requestUrl}/count`, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data.count;
  }
}
